// extracted by mini-css-extract-plugin
export default {"state":"InfoRequestComponent_state__ERcfq","SENT":"InfoRequestComponent_SENT__+pqfS","FAILED":"InfoRequestComponent_FAILED__5BTaP"};